import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import Container from 'containers/Container';

const Wrapper = styled.footer`
  position: sticky;
  z-index: 99;
  right: 0;
  bottom: 0;
  left: 0;

  padding: 13px 0;
  margin-top: 40px;
  box-sizing: border-box;
  border-top: 1px solid ${({theme}) => theme.variables.borderColor};
  box-shadow: 0 -15px 10px ${({theme}) => `
    ${transparentize(.9, theme.colors.black)};
  `};
  background: ${({theme}) => theme.variables.accentBackgroundColor};
  text-align: right;
`;

/**
 * This component renders the builder's footer.
 * @param {React.PropsWithChildren<any>} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function BuilderFooter(
    props: React.PropsWithChildren<any>,
): React.ReactElement<React.PropsWithChildren<any>> {
  return (
    <Wrapper>
      <Container>
        {props.children}
      </Container>
    </Wrapper>
  );
}
